<template>
  <div>
    <svg viewBox="0 0 500 500">
      <template v-for="(stat, index) in stats">
        <text text-anchor="end" x="120" :y="20 + index * 20">
          {{ stat.name }}
        </text>
        <line
          x1="125"
          :y1="17 + index * 20"
          :x2="125 + stat.value * 7"
          :y2="17 + index * 20"
        />
        <circle :cx="125 + stat.value * 7" :cy="17 + index * 20" r="4" />
        <text
          class="sort-order-increase"
          v-if="
            reOrderable && index > 0 && stats[index - 1].value == stat.value
          "
          x="160"
          :y="20 + index * 20"
          @click="increaseSubOrder(stat)"
        >
          move up
        </text>
      </template>
    </svg>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: {
    stats: { type: Array, default: () => [] },
    reOrderable: { type: Boolean, default: false }
  },
  methods: {
    increaseSubOrder: function(stat) {
      let newSubOrder = 1 + (stat.sub_order ? stat.sub_order : 0)
      this.fireEvent("via_result:increase_sub_order", {
        userId: stat.user_id,
        name: stat.name,
        value: stat.value,
        subOrder: newSubOrder,
        visible: stat.visible
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

line {
  stroke: $light-yellow;
  stroke-width: 4px;
}

circle {
  stroke: $light-yellow;
  fill: $light-yellow;
}

text {
  fill: $light-grey;
  font-style: italic;
  font-size: 0.5em;
}

text.sort-order-increase {
  cursor: pointer;
  fill: $orange;
  font-style: normal;
}
</style>
